import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-50d5238a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navigation-menu" }
const _hoisted_2 = { class: "navigation-btn__inner" }

import { nextTick } from "vue";
import { IonButton, IonIcon } from "@ionic/vue";
import { NavigationItem } from "@/interfaces/NavigationItem";
import { useRoute, useRouter } from "vue-router";
import useSubscription from "@/hooks/useSubscription";
import { RoleEnum, SubscriptionsTierEnum } from "@/generated/graphql";
import { EntitiesEnum } from "@/const/entities";
import useRoles from "@/hooks/useRole";


export default /*#__PURE__*/_defineComponent({
  __name: 'NavigationMenu',
  props: {
    items: {}
  },
  setup(__props: any) {



const route = useRoute();
const router = useRouter();
const { role } = useRoles()
const { type: subscriptionType } = useSubscription();

const navigate = (name: string, item:NavigationItem) => {
  if(item.queryParam){
    router.push({ 
      name, 
      params: {
        type: item.queryParam
      },
    });
  }else {
    router.push({ name });
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
      return (_openBlock(), _createBlock(_unref(IonButton), {
        fill: "clear",
        id: item.id,
        key: item.name,
        class: _normalizeClass(["navigation-btn", {
        'navigation-btn--main': item.isMainButton,
        'navigation-btn--active': (
          item?.queryParam === _unref(route).params[item.queryKey as any] &&
          Boolean(_unref(route).path.match(item.category ?? '')) ),
      }]),
        onClick: ($event: any) => (navigate(item.name, item))
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", {
              class: _normalizeClass(["navigation-btn__icon", { 
          'hover-icon': (Boolean(_unref(route).path.match(item.category ?? '')) && item.queryParam === _unref(route).params[item.queryKey as any]),
          'drop-ins hover-icon' : item.name===_unref(EntitiesEnum).FacilityDropins&&Boolean(
          _unref(route).path.match(item.category ?? '')),
          'passes hover-icon' : item.name===_unref(EntitiesEnum).FacilityPass&&Boolean(
            _unref(route).path.match(item.category ?? '')
          )
         }])
            }, [
              _createVNode(_unref(IonIcon), {
                src: item.icon
              }, null, 8, ["src"])
            ], 2),
            _createElementVNode("span", {
              class: _normalizeClass({
          'gold-color': (Boolean(_unref(route).path.match(item.category ?? '')) && item.queryParam === _unref(route).params[item.queryKey as any]),
        })
            }, _toDisplayString(item.label), 3)
          ])
        ]),
        _: 2
      }, 1032, ["id", "onClick", "class"]))
    }), 128))
  ]))
}
}

})